import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useLenis from "./hooks/useLenis";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { EditorialMarquee } from "./components/site/Marquee";
import { Services } from "./components/site/Services";
import { BeforeAfter } from "./components/site/BeforeAfter";
import { Promo } from "./components/site/Promo";
import { Trust } from "./components/site/Trust";
import { Reviews } from "./components/site/Reviews";
import { Blog } from "./components/site/Blog";
import { EstimateForm } from "./components/site/EstimateForm";
import { Footer } from "./components/site/Footer";

const Home = () => {
  useLenis();
  return (
    <div className="bg-fr-black text-white antialiased">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <BeforeAfter />
        <Promo />
        <Trust />
        <Reviews />
        <Blog />
        <EstimateForm />
      </main>
      <Footer />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
